import { COLUMNS } from './keys';
import { query } from './query';
import DataTable from '../../../../components/Datatable';
import { getDifference } from '../../../../helpers/showDelta';
import Loading from '../../../../components/Loading';
import LoadMoreComponent from '../../../../components/LoadMoreComponent';
import { v4 as uuid } from 'uuid';
import { scrollForTable } from '../../../../components/Datatable/utils';
import ExtraButtons from './extraBtns';
import { getFilters } from '../../../../components/Storage/getFilters';
import { withTranslation } from 'react-i18next';

class KeywordClusters extends LoadMoreComponent {
    constructor(props) {
        super();
        if (!props.data) this.query = query();

        this.offsetStep = 1000;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item.cluster_name?.toLowerCase().includes(search.toLowerCase()),
        );
    }

    componentDidUpdate(prevProps, prevState) {
        const filters = getFilters();
        const data = this.state.data?.map((x) => ({ id: uuid(), ...x }));

        if (prevState.filters !== filters && !this.state.loading) {
            return this.setState({ allData: data, filters });
        }
        if (
            JSON.stringify(this.state.data) !== JSON.stringify(prevState.data) &&
            !this.state.loading
        ) {
            this.setState({ allData: [...this.state.allData, ...data] });
        }

        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDatas({ key: 'keywordClusters', value: this.state.data });
        }
    }

    render() {
        const { t } = this.props;

        const data = this.state.allData?.length ? this.state.allData : this.props.data;
        if ((!data || !data.length) && this.state.loading) return <Loading padding={10} />;
        const sortFns = {
            cluster_name: (array) =>
                array.sort((a, b) => a.cluster_name.localeCompare(b.cluster_name)),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
            avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            weeks: (array) => array.sort((a, b) => a.weeks - b.weeks),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.impressions, a.impressionsPrior) -
                        getDifference(b.impressions, b.impressionsPrior),
                ),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.clicks, a.clicksPrior) -
                        getDifference(b.clicks, b.clicksPrior),
                ),
            avgPosition_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.avgPosition, a.avgPositionPrior) -
                        getDifference(b.avgPosition, b.avgPositionPrior),
                ),
            avgCTR_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.avgCTR, a.avgCTRPrior) -
                        getDifference(b.avgCTR, b.avgCTRPrior),
                ),
        };

        const extraBtns = () => <ExtraButtons t={t} />;

        return (
            <>
                <DataTable
                    nodes={data ?? []}
                    sortFns={sortFns}
                    extraBtns={extraBtns}
                    COLUMNS={COLUMNS}
                    fileName={t('opportunities.keyword_clusers.header')}
                    defaultSortKey="clicks"
                    searchFunction={this.searchFunction}
                    header={t('opportunities.keyword_clusers.header')}
                    forceRun={this.forceRun}
                    viewAllLink={`/domains/${window.info.id}/gsc-reports/algo-comparison/?view=keyword_clusters&defaultFilter=decline`}
                    showViewAll={true}
                    customEmptyMessage={this.props.message}
                    additionalStyles={{
                        Table: `
                                --data-table-library_grid-template-columns : minmax(120px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                        BaseCell: ` font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                        text-decoration: underline;
                                        }`,
                    }}
                />
                {(!data || !data?.length) && !this.state.filter && this.props.message && (
                    <div className="mt-10">
                        <div className="redirect-button">
                            <a
                                className="button button-filled button-primary"
                                href="/customers/change_plan/?without_basic=True"
                            >
                                {t('opportunities.adjust_plan')}
                            </a>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(KeywordClusters);
